module.exports = __webpack_public_path__ + "img/Fred.f8ef9d2f.jpg";